// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as _ from "lodash";
import * as React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { DndContext, pointerWithin } from "@dnd-kit/core";
import { restrictToFirstScrollableAncestor } from "@dnd-kit/modifiers";
import { SortableContext, rectSwappingStrategy } from "@dnd-kit/sortable";
import DashboardGridOverlay from "./DashboardGridOverlay";
import { DashboardService } from "../services";
import * as views from "./views";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardGrid = props => {
  const {
    type,
    dashboard,
    widgets
  } = props;
  const [activeId, setActiveId] = React.useState(null);
  const [items, setItems] = React.useState(widgets);
  const [minimalSize, setMinimalSize] = React.useState({
    width: Number.POSITIVE_INFINITY,
    height: Number.POSITIVE_INFINITY
  });
  const getByPosition = React.useCallback(position => _.find(items, {
    position
  }), [items]);
  const getPositionById = React.useCallback(id => Number.parseInt(_.last(_.split(id, "-")), 10), []);
  const getIndexById = React.useCallback(id => _.findIndex(items, {
    position: getPositionById(id)
  }), [items]);
  const handleDragStart = React.useCallback(({
    active
  }) => {
    if (!active) {
      return;
    }
    setActiveId(active.id);
  }, []);
  const handleDragEnd = React.useCallback(({
    active,
    over
  }) => {
    if (over) {
      const overPosition = getPositionById(over.id);
      const activePosition = getPositionById(active.id);
      if (activePosition !== overPosition) {
        setItems(items => {
          const newItems = _.map(items, i => ({
            ...i,
            position: i.position === activePosition ? overPosition : i.position === overPosition ? activePosition : i.position
          }));
          DashboardService.reorderWidgets(dashboard, [_.find(newItems, {
            position: activePosition
          }), _.find(newItems, {
            position: overPosition
          })]);
          return newItems;
        });
      }
    }
    setActiveId(null);
  }, [dashboard]);
  const handleDragCancel = React.useCallback(() => {
    setActiveId(null);
  }, []);
  const handleCreateWidget = React.useCallback(widget => {
    DashboardService.addWidget(dashboard, widget);
  }, [dashboard]);
  const handleDeleteWidget = React.useCallback(widget => {
    DashboardService.deleteWidget(dashboard, widget);
  }, [dashboard]);
  React.useEffect(() => {
    setItems(widgets);
  }, [widgets]);
  const view = views[`DashboardGridView${type}`];
  return view && /*#__PURE__*/_jsx("div", {
    className: "dashboard-grid",
    children: /*#__PURE__*/_jsx(SwitchTransition, {
      children: /*#__PURE__*/_jsx(CSSTransition, {
        addEndListener: (node, done) => node.addEventListener("transitionend", done, false),
        classNames: "fade",
        children: /*#__PURE__*/_jsxs(DndContext, {
          modifiers: [restrictToFirstScrollableAncestor],
          collisionDetection: pointerWithin,
          onDragStart: handleDragStart,
          onDragEnd: handleDragEnd,
          onDragCancel: handleDragCancel,
          children: [/*#__PURE__*/_jsx(SortableContext, {
            items: _.map(_.range(1, view.cells + 1), i => `${type}-${i}`),
            strategy: rectSwappingStrategy,
            children: /*#__PURE__*/React.createElement(view, {
              widgets: items,
              onCreate: handleCreateWidget,
              onDelete: handleDeleteWidget
            })
          }), activeId && /*#__PURE__*/_jsx(DashboardGridOverlay, {
            size: minimalSize,
            ...getByPosition(getPositionById(activeId))
          })]
        })
      }, type)
    })
  });
};
export default DashboardGrid;